import React from "react";
import { Link, Typography } from "@material-ui/core";
import styled from "styled-components";

const HelperText = styled(Typography)`
  font-style: italic;
  padding: 0em 1em 1em;
`;

export function getSMSAPIHelperText() {
  return (
    <>
      <HelperText>Having trouble connecting to an SMS API?</HelperText>
      <HelperText>
        Check your credentials <Link href="/test-credentials/entry">here</Link>
      </HelperText>
    </>
  );
}
